import {
  createRouter,
  createWebHashHistory,
  createWebHistory
} from 'vue-router'

import ViewUIPlus from 'view-ui-plus';

import VueCookies from 'vue-cookies'
import {
  Message,
} from 'view-ui-plus';

// 404页
import page_404 from '../views/sys/page_404.vue'
// 403页
import page_403 from '../views/sys/page_403.vue'

// 登录
import login_index from '../views/login/index.vue'
// 工作台
import workbench_index from '../views/workbench/index/index.vue'
// 身份证识别
import swiper_idcard_index from '../views/workbench/swiper_idcard/index.vue'
// 工作台-我的项目
import workbench_my_project from '../views/workbench/my_project/index.vue'
// 工作台-我的项目面试详情
import workbench_my_project_detail from '../views/workbench/my_project/detail.vue'
// 工作台-我的项目数据详情
import workbench_project_detail from '../views/workbench/project_detail/project_detail.vue'
// 工作台-我的项目-导入面试表
import workbench_my_project_import_daimianshi from '../views/workbench/my_project/import_daimianshi.vue'
// 项目介绍 
import project_introduction from '../views/workbench/project_introduction/index.vue'
// 项目介绍-详情
import project_introduction_info from '../views/workbench/project_introduction/info.vue'


// 日结项目
import workbench_daily_settlement from '../views/workbench/daily_settlement/index.vue'
// 日结项目-导入
import workbench_daily_settlement_import from '../views/workbench/daily_settlement/import_shift.vue'

// 工作台-查询员工
import workbench_query_staff from '../views/workbench/query_staff/index.vue'
// 工作台-查询员工-详情
import workbench_query_stafff_detail from '../views/workbench/query_staff/detail.vue'

// 部门管理-列表
import dep_manage_index from '../views/dep_manage/index.vue'
// 部门管理-部门权限
import dep_manage_auth_manage from '../views/dep_manage/auth_manage.vue'

//项目管理
import project_manage_create from '../views/project_manage/create.vue'
// 项目管理-列表
import project_manage_list from '../views/project_manage/list.vue'

//面试管理-流程
import interview_manage_flow_index from '../views/interview_manage/flow/index.vue'

//花名册管理-字段管理
import roster_manage_field from '../views/roster_manage/roster_field.vue'
// 花名册管理-花名册详情
import roster_manage_detail from '../views/roster_manage/roster_detail.vue'
// 花名册管理-模板管理
import roster_manage_template from '../views/roster_manage/roster_template.vue'
// 花名册管理-合同列表
import roster_manage_contract from '../views/roster_manage/roster_contract.vue'
// 花名册管理-短期工名单
import roster_manage_duanqi_roster from '../views/roster_manage/duanqi_roster.vue'


// 员工档案 
import staff_file_index from '../views/staff_file/index.vue'
// 员工技能证书
import staff_file_cert from '../views/staff_file/cert.vue'

// 数据面板-招聘数据
import data_panel_zhaopin from '../views/data_panel/zhaopin_data.vue'
// 数据面板-项目数据
import data_panel_xiangmu from '../views/data_panel/xiangmu_data.vue'
// 数据面板-借支数据
import data_panel_jiezhi from '../views/data_panel/jiezhi_data.vue'
// 数据面板-结算数据
import data_panel_jiesuan from '../views/data_panel/jiesuan.vue'
// 数据面板-完善数据
import data_panel_wanshan from '../views/data_panel/wanshan.vue'
// 数据面板-项目市占看板
import data_panel_market_share from '../views/data_panel/market_share.vue'
// 数据面板-服务人数看板
import data_panel_service_people from '../views/data_panel/service_people.vue'
// 数据面板-发薪人数看板
import data_panel_payment_people from '../views/data_panel/payment_people.vue'


// 面板管理-招聘面板管理
import panel_manage_zhaopin from '../views/panel_manage/zhaopin.vue'
// 面板管理-项目面板管理
import panel_manage_xiangmu from '../views/panel_manage/xiangmu.vue'
// 面板管理-合同审批权限管理
import panel_manage_contract from '../views/panel_manage/contract.vue'

// 手机页面
import h5_menu_index from '../view_h5/menu/index.vue'
// 项目列表
import h5_my_project_index from '../view_h5/my_project/index.vue'
// 项目列表-菜单
import h5_my_project_menu from '../view_h5/my_project/project_menu.vue'
// 项目扫码-添加面试
import h5_my_project_scan_detail from '../view_h5/my_project/scan_detail.vue'


// 项目开票
import finance_kaipiao from '../views/finance/kaipiao/index.vue'
// 项目开票历史
import finance_kaipiao_detail from '../views/finance/kaipiao/kaipiao_detail.vue'
// 项目开票抬头管理
import finance_invoice_title from '../views/finance/kaipiao/invoice_title.vue'
// 项目发薪
import finance_payment_index from '../views/finance/payment/index.vue'
// 项目发薪-申请记录
import finance_payment_detail from '../views/finance/payment/detail.vue'
// 项目发薪-补发
import finance_payment_bufa from '../views/finance/payment/bufa.vue';
// 项目发薪-主管申批
import finance_payment_audit from '../views/finance/payment/audit.vue';
// 项目发薪-获取银行卡信息
import transition_bankcard from '../views/finance/payment/transition_bankcard.vue'
// 员工个税核算
import finance_itax_index from '../views/finance/itax/index.vue'
//员工个税核算管理
import finance_itax_manage from '../views/finance/itax/itax_manage.vue'


// 项目工具
import poster_release_poster from '../views/tools/poster/release_poster.vue';
import universal_form_index from '../views/tools/universal_form/index.vue';
import compress_pdf from '../views/tools/compress/pdf.vue'
import public_kaipiao from "../views/tools/public_kaipiao/index.vue"

// 看板
import kanban01 from '../views/kanban/kanban01.vue'

//月底在职确认
import ticheng from '../views/ticheng/index.vue'


var page_title = '大象·项目'
const routes = [{

  path: '/:catchAll(.*)',
  name: 'catchAll',
  component: page_404,
  meta: { title: page_title }
},
{

  path: '/page_404',
  name: 'page_404',
  component: page_404,
  meta: { title: page_title }
}, {

  path: '/page_403',
  name: 'page_403',
  component: page_403,
  meta: { title: page_title }
},
{
  path: '/',
  name: 'login_index',
  component: login_index,
  meta: { title: page_title }
},

{
  path: '/workbench/index',
  name: 'workbench_index',
  component: workbench_index,
  meta: { title: page_title }
},

{
  path: '/workbench/my_project',
  name: 'workbench_my_project',
  component: workbench_my_project,
  meta: { title: '我的项目' }
},
{
  path: '/workbench/swiper_idcard',
  name: 'swiper_idcard_index',
  component: swiper_idcard_index,
  meta: { title: page_title }
},
{
  path: '/workbench/my_project/detail',
  name: 'workbench_my_project_detail',
  component: workbench_my_project_detail,
  meta: { title: '项目详情' }
},
{
  path: '/workbench/project_detail',
  name: 'workbench_project_detail',
  component: workbench_project_detail,
  meta: { title: '项目详情' }
},
{
  path: '/workbench/my_project/import_daimianshi',
  name: 'workbench_my_project_import_daimianshi',
  component: workbench_my_project_import_daimianshi,
  meta: { title: page_title }
},
{
  path: '/workbench/daily_settlement',
  name: 'workbench_daily_settlement',
  component: workbench_daily_settlement,
  meta: { title: page_title }
},
{
  path: '/workbench/daily_settlement/import',
  name: 'workbench_daily_settlement_import',
  component: workbench_daily_settlement_import,
  meta: { title: page_title }
},
{
  path: '/workbench/query_staff',
  name: 'workbench_query_staff',
  component: workbench_query_staff,
  meta: { title: '员工查询' }
},
{
  path: '/project_introduction',
  name: 'project_introduction',
  component: project_introduction,
  meta: { title: '项目介绍' }
},
{
  path: '/project_introduction/info',
  name: 'project_introduction/info',
  component: project_introduction_info,
  meta: { title: '项目介绍详情' }
},
{
  path: '/query_staff',
  name: 'workbench_query_stafff_detail',
  component: workbench_query_stafff_detail,
  meta: { title: '员工查询' }
},



{
  path: '/project_manage/create',
  name: 'project_manage_create',
  component: project_manage_create,
  meta: { title: page_title }
},
{
  path: '/project_manage/list',
  name: 'project_manage_list',
  component: project_manage_list,
  meta: { title: '项目列表' }
},


{
  path: '/dep_manage/index',
  name: 'dep_manage_index',
  component: dep_manage_index,
  meta: { title: page_title }
},

{
  path: '/dep_manage/auth_manage',
  name: 'dep_manage_auth_manage',
  component: dep_manage_auth_manage,
  meta: { title: page_title }
},

{
  path: '/interview_manage/flow',
  name: 'interview_manage_flow_index',
  component: interview_manage_flow_index,
  meta: { title: page_title }
},


{
  path: '/roster_manage/field',
  name: 'roster_manage_field',
  component: roster_manage_field,
  meta: { title: page_title }
},
{
  path: '/roster_manage/detail',
  name: 'roster_manage_detail',
  component: roster_manage_detail,
  meta: { title: page_title }
},
{
  path: '/roster_manage/template',
  name: 'roster_manage_template',
  component: roster_manage_template,
  meta: { title: page_title }
},
{
  path: '/roster_manage/contract',
  name: 'roster_manage_contract',
  component: roster_manage_contract,
  meta: { title: page_title }
},
{
  path: '/roster_manage/duanqi_roster',
  name: 'roster_manage_duanqi_roster',
  component: roster_manage_duanqi_roster,
  meta: { title: '项目·短期工花名册' }
},


{
  path: '/data_panel/zhaopin',
  name: 'data_panel_zhaopin',
  component: data_panel_zhaopin,
  meta: { title: page_title }
},
{
  path: '/data_panel/xiangmu',
  name: 'data_panel_xiangmu',
  component: data_panel_xiangmu,
  meta: { title: page_title }
},
{
  path: '/data_panel/jiezhi',
  name: 'data_panel_jiezhi',
  component: data_panel_jiezhi,
  meta: { title: '借支核销' }
},
{
  path: '/data_panel/jiesuan',
  name: 'data_panel_jiesuan',
  component: data_panel_jiesuan,
  meta: { title: page_title }
},
{
  path: '/data_panel/wanshan',
  name: 'data_panel_wanshan',
  component: data_panel_wanshan,
  meta: { title: page_title }
},

{
  path: '/panel_manage/zhaopin',
  name: 'panel_manage_zhaopin',
  component: panel_manage_zhaopin,
  meta: { title: page_title }
},
{
  path: '/panel_manage/xiangmu',
  name: 'panel_manage_xiangmu',
  component: panel_manage_xiangmu,
  meta: { title: '项目数据权限' }
},
{
  path: '/panel_manage/contract',
  name: 'panel_manage_contract',
  component: panel_manage_contract,
  meta: { title: '项目合同审批权限' }
},

{
  path: '/staff_file',
  name: 'staff_file_index',
  component: staff_file_index,
  meta: { title: page_title }
},



{
  path: '/h5/menu',
  name: 'h5_menu_index',
  component: h5_menu_index,
  meta: { title: page_title }
},

{
  path: '/h5/my_project',
  name: 'h5_my_project_index',
  component: h5_my_project_index,
  meta: { title: page_title }
},

{
  path: '/h5/my_project/menu',
  name: 'h5_my_project_menu',
  component: h5_my_project_menu,
  meta: { title: page_title }
},
{
  path: '/h5/my_project/scan_detail',
  name: 'h5_my_project_scan_detail',
  component: h5_my_project_scan_detail,
  meta: { title: page_title }
},
{
  path: '/finance/kaipiao',
  name: 'finance_kaipiao',
  component: finance_kaipiao,
  meta: { title: '发起结算-开票' }
},
{
  path: '/finance/kaipiao/invoice_title',
  name: 'finance_kaipiao_invoice_title',
  component: finance_invoice_title,
  meta: { title: '开票抬头管理' }
},
{
  path: '/finance/kaipiao_detail',
  name: 'finance_kaipiao_detail',
  component: finance_kaipiao_detail,
  meta: { title: '结算详情' }
},
{
  path: '/finance/payment',
  name: 'finance_payment_index',
  component: finance_payment_index,
  meta: { title: '项目发薪' }
},
{
  path: '/finance/payment/detail',
  name: 'finance_payment_detail',
  component: finance_payment_detail,
  meta: { title: '项目发薪申请记录' }
}, {
  path: '/finance/payment/audit',
  name: 'finance_payment_audit',
  component: finance_payment_audit,
  meta: { title: '项目发薪-主管审批' }
},
{
  path: '/finance/payment/transition_bankcard',
  name: 'transition_bankcard',
  component: transition_bankcard,
  meta: { title: '银行卡信息获取' }
},
{
  path: '/finance/payment/bufa',
  name: 'finance_payment_bufa',
  component: finance_payment_bufa,
  meta: { title: '发薪补发' }
},
{
  path: '/finance/itax',
  name: 'finance_itax_index',
  component: finance_itax_index,
  meta: { title: '员工个税核算' }
},
{
  path: '/finance/itax/manage',
  name: 'finance_itax_manage',
  component: finance_itax_manage,
  meta: { title: '个税核算队列管理' }
},
{
  path: '/tools/release_poster',
  name: 'poster_release_poster',
  component: poster_release_poster,
  meta: { title: '项目招聘海报' }
},
{
  path: '/tools/universal_form',
  name: 'universal_form_index',
  component: universal_form_index,
  meta: { title: '万能表单' }
},
{
  path: '/staff_file/cert',
  name: 'staff_file_cert',
  component: staff_file_cert,
  meta: { title: '员工技能证书' }
},


{
  path: '/kanban01',
  name: 'kanban01',
  component: kanban01,
  meta: { title: '看板01' }
},
{
  path: '/data_panel/market_share',
  name: 'data_panel_market_share',
  component: data_panel_market_share,
  meta: { title: '项目市占看板' }
},
{
  path: '/data_panel/service_people',
  name: 'data_panel_service_people',
  component: data_panel_service_people,
  meta: { title: '服务人数看板' }
},
{
  path: '/data_panel/payment_people',
  name: 'data_panel_payment_people',
  component: data_panel_payment_people,
  meta: { title: '发薪人数看板' }
},
{
  path: '/ticheng',
  name: 'ticheng',
  component: ticheng,
  meta: { title: '月底在职确认' }
},
{
  path: '/tools/compress/pdf',
  name: 'compress_pdf',
  component: compress_pdf,
  meta: { title: 'pdf压缩' }
},
{
  path: '/tools/public_kaipiao',
  name: 'public_kaipiao',
  component: public_kaipiao,
  meta: { title: '开票信息公开' }
},






]

const router = createRouter({
  history: createWebHistory(),
  routes,
  ViewUIPlus
})


var pass_path = ['/', '/query_staff']



router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  if (pass_path.indexOf(to.path) != -1) {
    next()
  } else {
    var dx_token = VueCookies.get('dx_token')
    if (dx_token) {
      next()
    } else {
      Message.warning('R0-您当前还未登录，1秒后跳转至登录页面~');
      setTimeout(function () {
        var current_href = window.location.href;
        var auth_url = process.env.VUE_APP_AUTH_URL;
        open_new_page(auth_url + '?redirect_url=' + current_href, '_self')
      }, 1000)
      // next('/?redirect_url='+current_href)
    }

  }
})


ViewUIPlus.LoadingBar.config({
  color: "#6699CC"
});


router.beforeEach((to, from, next) => {
  ViewUIPlus.LoadingBar.start();
  next();
});

router.afterEach(route => {
  ViewUIPlus.LoadingBar.finish();
});



// 

// 跳转函数
function open_new_page(url, target) {
  if (!target) {
    target = '_blank'
  }
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", target);
  var id = String(new Date().getTime())
  a.setAttribute("id", id);
  // 防止反复添加      
  document.body.appendChild(a);
  a.click();

}




export default router